module.exports = __webpack_public_path__ + "static/media/bloodytuesday.61d29896.svg";